import type { IResultstash, JsonQuery } from "@mne-core/api";
import { QueryController, createHeaders, fetchJsonQuery } from "@mne-core/api";

import type { IAuthenticationData } from "../@types";
import AuthenticationURI from "./AuthenticationURIBuilder";

export interface ISubmitOpenIDAuthCodeByProviderIDCriteria {
  authorizationCode?: string;
  flow?: "authorizationCode" | "idToken";
  provider: string;
  idToken?: string;
  requestedAuthorizations?: ["enrollPublicKey" | "setPassword"];
}

export interface ISubmitOpenIDAuthCodeByProviderIDOpts extends RequestInit {
  apiUrl: string;
  ctrl?: QueryController;
}

export const createRequest = (
  criteria: ISubmitOpenIDAuthCodeByProviderIDCriteria,
  opts: ISubmitOpenIDAuthCodeByProviderIDOpts,
): Request => {
  const { apiUrl, ...restOpts } = opts;
  const { provider, ...restCriteria } = criteria;

  const uri = new AuthenticationURI().setApiUrl(apiUrl).setSegment(["openid", "provider", provider, "authentication"]);

  const headers = createHeaders({
    Accept: "application/json",
    "Content-type": "application/json",
  });

  const localRequestOpts: RequestInit = {
    body: JSON.stringify(restCriteria),
    credentials: "include",
    headers,
    method: "POST",
    mode: "cors",
  };

  return new Request(String(uri), {
    ...localRequestOpts,
    ...restOpts,
  });
};

async function requestRedirectURIByProviderID(
  criteria: ISubmitOpenIDAuthCodeByProviderIDCriteria,
  opts: ISubmitOpenIDAuthCodeByProviderIDOpts,
): Promise<JsonQuery<IResultstash<IAuthenticationData>>> {
  return await fetchJsonQuery<IResultstash<IAuthenticationData>>(createRequest(criteria, opts), {
    ctrl: opts.ctrl || new QueryController(),
  });
}

export default requestRedirectURIByProviderID;
